/**
 * This file contains common Tailwind CSS class combinations that are used throughout the application.
 * Using this approach keeps styling consistent and makes it easier to update styles in one place.
 */

export const twClasses = {
  // Layout
  pageContainer: 'w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4 box-border',
  
  // Components
  card: 'bg-white rounded-card shadow-card p-6 h-full',
  cardHeader: 'pb-4 mb-4 border-b border-divider font-semibold text-base',
  cardContent: 'p-6',
  
  // Loading states
  loadingContainer: 'flex justify-center items-center h-64',
  
  // Typography
  heading: 'font-semibold mb-4',
  subheading: 'text-gray-500 mb-1',
  paragraph: 'text-gray-600',
  
  // Form elements
  formInput: 'w-full h-[42px] rounded mb-4 border border-gray-300 px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary-main focus:border-primary-main',
  formSelect: 'w-full h-[42px] rounded mb-4 border border-gray-300 px-3 py-2 focus:outline-none focus:ring-1 focus:ring-primary-main focus:border-primary-main',
  
  // Buttons
  button: 'font-semibold py-2 px-4 rounded-lg text-sm',
  buttonPrimary: 'bg-primary-main text-white hover:bg-primary-dark',
  buttonSecondary: 'bg-secondary-main text-white hover:bg-secondary-dark',
  buttonOutline: 'border border-primary-main text-primary-main hover:bg-primary-main hover:text-white',
  
  // Status elements
  alert: 'p-4 mb-4 rounded-md',
  alertSuccess: 'bg-green-50 text-green-800',
  alertError: 'bg-red-50 text-red-800',
  alertWarning: 'bg-yellow-50 text-yellow-800',
  alertInfo: 'bg-blue-50 text-blue-800',
  
  // Spacing
  spacingY: 'space-y-4',
  spacingX: 'space-x-4',
  
  // Grid layouts
  grid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6',
  gridTwoColumn: 'grid grid-cols-1 md:grid-cols-2 gap-6',
};

/**
 * Combine multiple Tailwind utility classes
 * @param classes Array of class strings to combine
 * @returns Combined class string
 */
export const combineClasses = (...classes: string[]): string => {
  return classes.filter(Boolean).join(' ');
}; 